import { type ScanContext } from '../types/scanContext.type';
import { type RawScanEvent, type ScanEvent } from '../types/scanEvent.type';

const CONTROL_WHITESPACE = /[\t\n\r\f\v]/g;
const normalizeBarcodeValue = (barcodeValue: string) =>
  barcodeValue.replace(CONTROL_WHITESPACE, '').trim();

export const createScanEvent = (
  rawScanEvent: RawScanEvent,
  scanContext: ScanContext,
): ScanEvent => ({
  ...rawScanEvent,
  barcode_value: normalizeBarcodeValue(rawScanEvent.barcode_value),
  scan_context: scanContext,
});
